import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { BlockContainer } from './css';
import request from '../../../../../../utils/request';

import BlockItem from './components/blockItem';

const Block = ({ data }) => {
  const [orderPermissions, setOrderPermissions] = useState([]);

  const fetchOrderPermissions = async () => {
    try {
      const result = await request.get('/order-permissions-dates');

      if (result && result.status === 200) {
        setOrderPermissions(result.data.data);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchOrderPermissions();
  }, []);

  return (
    <BlockContainer>
      {data.map(rowData => (
        <BlockItem
          key={rowData.name}
          data={rowData}
          orderPermissions={orderPermissions}
          onUpdatePermission={fetchOrderPermissions}
        />
      ))}
    </BlockContainer>
  );
};

Block.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      permissions: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          description: PropTypes.string
        })
      )
    })
  ).isRequired
};

export default Block;
